var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.581,
    height: 15.581,
    viewBox: "0 0 15.581 15.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514",
    transform: "translate(-5118.5 89.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M9.515,4.664a1.421,1.421,0,0,1-.034.309.645.645,0,0,1-.129.27.673.673,0,0,1-.27.191,1.193,1.193,0,0,1-.455.073,1.274,1.274,0,0,1-.472-.073.644.644,0,0,1-.275-.2.632.632,0,0,1-.124-.27,1.6,1.6,0,0,1-.028-.3.961.961,0,0,1,.18-.59.858.858,0,0,1,.719-.242,1.348,1.348,0,0,1,.444.062.658.658,0,0,1,.275.174.574.574,0,0,1,.135.264A1.529,1.529,0,0,1,9.515,4.664Zm-.056,6.767a.372.372,0,0,1-.039.169q-.039.079-.185.079H8a.234.234,0,0,1-.2-.067.293.293,0,0,1-.051-.18V6.373A.288.288,0,0,1,7.8,6.187.247.247,0,0,1,8,6.125H9.234q.146,0,.185.084a.385.385,0,0,1,.039.163Z",
    transform: "translate(5117.595 -89.319)",
    fill: "#47b149"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(5119 -89)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 7.29,
    cy: 7.29,
    r: 7.29,
    fill: "rgba(0,0,0,0)",
    stroke: "#47b149",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.41069c3eb5e1200eaa8fc7e20dfc226b.svg";
export { ForwardRef as ReactComponent };